export const checkReversePrice = (data) => {
	if (data?.reverse) {
		return data?.total - data?.reverse_total;
	}
	return data?.total;
};
